import React from "react";
export default function About() {
  return (
    <div
      id="about"
      className="px-[10%] max-[1300px]:px-[5%] py-20 max-[455px]:py-10 bg-[#04090F] text-white w-[100%]"
    >
      <div className="text-left text-4xl max-[1300px]:text-3xl max-[992px]:text-2xl font-bold">
        About
      </div>
      <div className="w-[50%] max-[634px]:w-[75%] mt-4 max-[992px]:text-sm max-[634px]:text-xs max-[455px]:text-[10px]">
        Based in Patna, India, I am a passionate developer committed to
        mastering the art of coding and crafting innovative applications,
        websites, and mobile apps. My expertise lies in developing dynamic
        WebApps and websites, constructing robust APIs, and designing
        applications for both Web and Android platforms. With a steadfast
        dedication to self-improvement, I continuously strive to enhance my
        skills through rigorous independent practice, ensuring that my technical
        abilities remain at the cutting edge of technology.
      </div>
    </div>
  );
}
